import Swiper from 'swiper';
import {
  Navigation,
  Pagination,
  Keyboard,
  HashNavigation,
  Virtual,
} from 'swiper/modules';

export const fullscreenSlideshow = async (err) => {
  if (err) {
    console.error(err);
  }

  /*
   * Generate fullscreen slideshow from images within a .has-fullscreen-slider container.
   * Trigger fullscreen slideshow on image click.
   * Use swiper.js for slideshow features.
   */

  // Get closest .has-fullscreen-slider parent element and get all images
  // Do it on click on one of the images within the .has-fullscreen-slider container

  document.addEventListener('click', function (e) {
    // Check if clicked element is an image within a .has-fullscreen-slider container

    if (
      !e.target.closest('.onecol.slideshow__swiper') ||
      (e.target.tagName.toLowerCase() !== 'img' &&
        e.target.tagName.toLowerCase() !== 'span')
    )
      return;

    // Get all images within the .has-fullscreen-slider container
    const allSlideShowImages = e.target
      .closest('.onecol.slideshow__swiper')
      .querySelectorAll('img');
    if (!allSlideShowImages) return;

    // Get index of clicked image within allSlideShowImages

    // Get the clicked image element and remove leading slash from src attribute if present (to match with src attribute of allSlideShowImages)

    const clickedImage = e.target.parentElement.querySelector('img');
    if (clickedImage.src.startsWith('/')) {
      clickedImage.src = clickedImage.src.substring(1);
    }

    let index = 0;

    allSlideShowImages.forEach((slideShowImage, i) => {
      /*       console.log('Comparing clicked image with slideshow image:', {
        clickedImageSrc: clickedImage.src,
        slideShowImageSrc: slideShowImage.src,
      }); */

      if (slideShowImage === clickedImage) {
        index = i;
      }
    });

    console.log('Clicked image index:', index);

    // add swiper navigation elements to the DOM
    const swiperContainer = document.createElement('div'),
      htmlEl = document.querySelector('html');

    // Append to body tag
    document.body.appendChild(swiperContainer);

    swiperContainer.classList.add('swiper-container');
    swiperContainer.innerHTML = `
        <div class="swiper-wrapper"></div>
        <div class="close-impressions-slider">
          <div class="close-btn">Schliessen</div>
        </div>
  
        <div class="swiper-buttons">
          <div class="swiper-button-next"></div>
          <div class="swiper-button-prev"></div>
        </div>
        <div class="swiper-pagination"></div>
        `;

    htmlEl.classList.add('fullscreen-slideshow');

    var impressionSlider = new Swiper('.swiper-container', {
      // configure Swiper to use modules
      modules: [Navigation, Pagination, Keyboard, HashNavigation, Virtual],
      //preloadImages: true,
      slidesPerView: 1,
      loop: false,
      speed: 500,
      allowTouchMove: true,
      mousewheel: true,
      keyboard: {
        enabled: true,
      },
      navigation: {
        nextEl: '.fullscreen-slideshow .swiper-buttons .swiper-button-next',
        prevEl: '.fullscreen-slideshow .swiper-buttons .swiper-button-prev',
      },
      pagination: {
        el: '.fullscreen-slideshow .swiper-pagination',
        clickable: true,
        type: 'fraction',
      },
      virtual: {
        slides: (function () {
          var slides = [];
          allSlideShowImages.forEach((slideShowImage) => {
            // render img tag from slideShowImage src and alt attribute
            slides.push(
              `<img src="${slideShowImage.src}" alt="${slideShowImage.alt}"/>`,
            );
          });
          return slides;
        })(),
      },
    });

    impressionSlider.slideTo(index, 1);

    // Also close on escape key press
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        htmlEl.classList.remove('fullscreen-slideshow');
        // Destroy swiper instance
        impressionSlider.destroy();
        // Remove swiper-container markup from DOM
        swiperContainer.remove();
      }
    });

    // Close on close button click
    document.addEventListener('click', function (e) {
      const target = e.target.closest('.close-btn');

      if (!target) return;

      htmlEl.classList.remove('fullscreen-slideshow');
      //target.parentElement.parentElement.classList.remove('swiper-active');
      // Destroy swiper instance
      impressionSlider.destroy();
      // Remove swiper-container markup from DOM
      swiperContainer.remove();

      e.preventDefault();
    });
  });
};

import.meta.webpackHot?.accept(fullscreenSlideshow);
